import { cloneDeep, isMatch, snakeCase } from 'lodash';
import { ReportCalc } from '../../services/report.class';

export class DailyReportController {
  inited = false;
  isLoaded = false;
  isChanged = false;
  isSaving = false;
  otherVisible = false;
  originalModel;
  model;
  productsTable;
  currentShop;
  snakeCase: Function = snakeCase;
  onRefresh: Function;
  selectedServices: Object[] = [];
  selectedOffers: Object[] = [];
  selectedProducts: Object[] = [];
  mode: String;
  report;

  cashInfo = [
    { step: '0.01', name: 'totalPos' },
    { step: '0.01', name: 'deposit' },
    { step: '5', name: 'bills' },
    { step: '0.01', name: 'coins' }
  ];

  readOnly: Boolean = true;
  isManager: Boolean = true;
  isViewer: Boolean = true;
  reportCalc: ReportCalc;

  changeTimeout;
  /*@ngInject*/
  constructor(
    private Shop,
    private Auth,
    protected DailyReport,
    protected $timeout
  ) {}

  $onInit() {
    // console.log('onInit', this.report);
    // if (this.report) {
    //   this.model = this.report;
    //   this.isLoaded = true;
    // } else {
    this.refreshData();
    // }
  }

  refreshData() {
    // console.log('refresh data in mode', this.mode);
    var vm = this;

    this.isLoaded = false;
    this.Auth.getCurrentUser(user => {
      console.log('user', user, 'mode', this.mode);
      this.readOnly = this.mode !== 'create' || user.role !== 'shop';
      this.isManager = user.role === 'manager' || user.role === 'admin';
      this.isViewer = user.role === 'viewer';

      if (!this.readOnly) {
        this.Shop.query(
          { user: user._id },
          ([shop]) => {
            if (shop) {
              this.currentShop = cloneDeep(shop);
              shop.$currentDailyReport(report => {
                this.originalModel = cloneDeep(report);
                this.model = report;
                this.reportCalc = new ReportCalc(report, this.currentShop);
                this.productsTable = this.reportCalc.buildProductsTableStructure();
                this.inited = true;
                this.isLoaded = true;
                let query = { id: this.currentShop._id, actionId: report._id };
                console.log('getReportBefore', query);
                this.DailyReport.getReportBefore(query, report => {
                  console.log('report before', report);
                  if (report) {
                    this.model.startCash =
                      (report.bills || 0) + (report.coins || 0);
                  } else {
                    this.model.startCash = 0;
                  }
                });
              });
            } else {
              console.error('shop for user not found, access denied.');
              this.isLoaded = true;
              this.refreshData();
            }
          },
          e => {
            console.error('error', e);
          }
        );
      } else if (this.mode === 'review') {
        // console.log('setting report', this.report, 'and loaded to true');
        // this.DailyReport.get(this.report._id, report => {
        this.model = this.report;
        if (!this.isViewer) {
          this.reportCalc = new ReportCalc(this.report, false);
          this.productsTable = this.reportCalc.buildProductsTableStructure();
          this.DailyReport.getReportBefore(
            { id: this.currentShop._id, actionId: this.model._id },
            report => {
              console.log('report before', report);
              this.model.startCash = (report.bills || 0) + (report.coins || 0);
            }
          );
        }
        this.isLoaded = true;
        this.inited = true;

        // });
      }
    });
  }
  updateService(index, service) {
    // this.model.services
    //   .find(soldService => this.compareSchema(soldService.service, service))
    //   .quantity = this.selectedServices[index];
    this.saveChanges();
  }
  updateOffer(parentIndex, index, service, availableOffer) {
    // let soldService = this.model.services
    //   .find(soldService => this.compareSchema(soldService.service, service));
    // soldService.offersQuantity[index] = this.selectedOffers[parentIndex][index];
    // soldService.offers[index] = availableOffer.;
    this.saveChanges();
  }
  updateProduct(parentIndex, index, assistant, product) {
    // this.model.products
    //   .find(soldProduct => this.compareSchema(soldProduct.product, product) && this.compareSchema(soldProduct.assistant, assistant))
    //   .quantity = this.selectedProducts[parentIndex][index];
    this.saveChanges();
  }
  saveChangesN = 0;
  saveChanges() {
    this.isChanged = true;
    // this.saveChangesN++;
    // console.log('save changes', this.readOnly, this.saveChangesN);
    // if (this.inited && this.saveChangesN > 1) {
    //   // debugger;
    //   if (this.changeTimeout != null) {
    //     this.$timeout.cancel(this.changeTimeout);
    //     this.changeTimeout = null;
    //   }
    //   this.changeTimeout = this.$timeout(() => {
    //     this.applyChanges();
    //   }, 1000);
    // }
  }
  applyChanges() {
    this.isChanged = true;
    // if (this.inited) {
    //   if (this.changeTimeout != null) {
    //     this.$timeout.cancel(this.changeTimeout);
    //     this.changeTimeout = null;
    //   }
    //   console.log('apply changes', this.model, '\nreadonly', this.readOnly, 'equals', isMatch(this.model, this.originalModel));
    //   if (!isMatch(this.model, this.originalModel)) {
    //     this.updateChanges();
    //   }
    // }
  }
  updateChanges() {
    console.log('saving changes');
    this.isSaving = true;
    this.model.totalReceipts = this.reportCalc.getTotal();
    this.DailyReport.update(
      this.model,
      res => {
        console.log('save ok', res, this.model);
        this.refreshData();
        this.isChanged = false;
        this.isSaving = false;
      },
      err => {
        console.error('err', err);
      }
    );
  }
  deleteNotes() {
    if (this.isManager) {
      this.DailyReport.deleteNotes(
        { id: this.model._id },
        res => {
          console.log('save ok', res, this.model);

          if (this.mode === 'review') {
            this.onRefresh();
          } else {
            this.refreshData();
          }
          this.isChanged = false;
          this.isSaving = false;
        },
        err => {
          console.error('err', err);
        }
      );
    }
  }
  toggleWithdrawn() {
    if (this.isManager) {
      this.DailyReport.toggleWithdrawn(
        { id: this.model._id },
        res => {
          console.log('save ok', res, this.model);
          this.model = res;
          this.isChanged = false;
          this.isSaving = false;
        },
        err => {
          console.error('err', err);
        }
      );
    }
  }

  getInputName(...args) {
    return args.map(arg => (arg ? arg : '').replace(' ', '-')).join('_');
  }
  toggleOthers() {
    this.otherVisible = !this.otherVisible;
  }
  protected compareSchema(el1, el2) {
    return el1._id === el2._id;
  }
}



// WEBPACK FOOTER //
// ./client/components/dailyReport/dailyReport.controller.ts